import api from "Helpers/Api";
import { FairsListResponse, IFairUpdate } from "Services/Fairs/fairs";

export default async function fairCreate(params: IFairUpdate) {
  const { data } = await api.post<FairsListResponse>(`/fairs/create`, params);

  return data;
}
